/**
 * Abre navegación nativa según el sistema operativo:
 * - iOS  → Apple Maps (maps://)
 * - Resto → Google Maps (https)
 *
 * @param {number} destLat
 * @param {number} destLng
 * @param {number|null} originLat  — null usa ubicación actual del dispositivo
 * @param {number|null} originLng
 */
export function openMapsNavigation(destLat, destLng, originLat = null, originLng = null) {
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (isIOS) {
    const saddr = originLat != null && originLng != null
      ? `${originLat},${originLng}`
      : "current+location";
    window.location.href =
      `maps://maps.apple.com/?saddr=${saddr}&daddr=${destLat},${destLng}&dirflg=d`;
  } else {
    const origin = originLat != null && originLng != null
      ? `&origin=${originLat},${originLng}`
      : "";
    window.open(
      `https://www.google.com/maps/dir/?api=1${origin}&destination=${destLat},${destLng}&travelmode=driving&dir_action=navigate`,
      "_blank",
    );
  }
}

/**
 * Navega a una dirección de texto. Útil cuando no hay coordenadas disponibles.
 * @param {string} address
 * @param {number|null} originLat
 * @param {number|null} originLng
 */
export function openMapsNavigationByAddress(address, originLat = null, originLng = null) {
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const encoded = encodeURIComponent(address);

  if (isIOS) {
    const saddr = originLat != null && originLng != null
      ? `${originLat},${originLng}`
      : "current+location";
    window.location.href = `maps://maps.apple.com/?saddr=${saddr}&daddr=${encoded}&dirflg=d`;
  } else {
    const origin = originLat != null && originLng != null
      ? `&origin=${originLat},${originLng}`
      : "";
    window.open(
      `https://www.google.com/maps/dir/?api=1${origin}&destination=${encoded}&travelmode=driving&dir_action=navigate`,
      "_blank",
    );
  }
}
